export default "/images/vendor/flag-icon-css/flags/1x1/mw.svg?6807c4fdd0370b23d239d22883ecf478";